var _a;
import { atom } from 'recoil';
import { getCampaignDialogChecked } from '../localStorage';
export var campaignCheckedState = atom({
    key: 'campaignCheckedState',
    default: ((_a = getCampaignDialogChecked()) === null || _a === void 0 ? void 0 : _a.checked) !== 1,
});
